import { buildUrl } from 'embed/utils'
import { fetch } from 'whatwg-fetch'

export class IpAddress {
  ipAddress: string | undefined

  public async getFromIpify(): Promise<string> {
    const url = buildUrl('https://api.ipify.org', { format: 'json' })
    const request = await fetch(url.href, {
      method: 'GET',
    })
    const response = await request.json()
    return response.ip
  }

  public async getFromFiona(): Promise<string> {
    const url = buildUrl('https://fiona.com/api/lambdas/location', { format: 'json' })
    const request = await fetch(url.href, {
      method: 'GET',
    })
    const response = await request.json()
    return response.ipAddress
  }

  public async get() {
    if (this.ipAddress) return this.ipAddress
    const whoeverReturnsFirst = new Promise<string>((resolve) => {
      let resolved = false
      // Can't use promise.any without upgrading us to es2021
      const resolveIfFirst = (value: unknown) => {
        if (!resolved && typeof value === 'string') {
          resolved = true
          resolve(value)
        }
      }
      void this.getFromFiona().then(resolveIfFirst)
      void this.getFromIpify().then(resolveIfFirst)
    })
    this.ipAddress = await whoeverReturnsFirst
    return this.ipAddress
  }
}

export default new IpAddress()
